import React from 'react';
import { useIntl } from 'react-intl';

import RhfTextField from '../FormField/RhfTextField';
import RhfAutocomplete from '../FormField/RhfAutocomplete';

import { FieldsGrid, FullSpan } from './StyledComponents';

type Option = { label: string; value: string };

type Props = {
  context: { bankAccounts?: Option[]; payingProviders?: Option[] };
  isEdit: boolean;
};

const OpenFinanceFields: React.FC<Props> = ({ context, isEdit }) => {
  const { formatMessage } = useIntl();

  const bankAccounts = context.bankAccounts ?? [];
  const payingProviders = context.payingProviders ?? [];

  return (
    <FieldsGrid>
      <RhfTextField
        name="name"
        label={formatMessage({
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.name',
          defaultMessage: 'Name',
        })}
        required
        autoFocus
      />
      <RhfTextField
        name="psuId"
        label={formatMessage({
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.psuId',
          defaultMessage: 'PSU ID',
        })}
        required
        disabled={isEdit}
      />

      <RhfAutocomplete
        name="glBankAccountId"
        label={formatMessage({
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.bankAccount',
          defaultMessage: 'GL Bank Account',
        })}
        options={bankAccounts}
        required
        disableClearable
      />
      <RhfAutocomplete
        name="providerId"
        label={formatMessage({
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.providerId',
          defaultMessage: 'Bank',
        })}
        options={payingProviders}
        required
        disableClearable
        disabled={isEdit}
      />

      {/* The account is entered as 3 parts; the Israeli IBAN is assembled from
          them at submit time (see helpers `toPayload`) — no preview is shown. */}
      <RhfTextField
        name="bankCode"
        label={formatMessage({
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.bankCode',
          defaultMessage: 'Bank Code',
        })}
        required
        disabled={isEdit}
      />
      <RhfTextField
        name="branchCode"
        label={formatMessage({
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.branchCode',
          defaultMessage: 'Branch Code',
        })}
        required
        disabled={isEdit}
      />
      <FullSpan>
        <RhfTextField
          name="accountNumber"
          label={formatMessage({
            id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.accountNumber',
            defaultMessage: 'Account number',
          })}
          required
          disabled={isEdit}
        />
      </FullSpan>
    </FieldsGrid>
  );
};

export default OpenFinanceFields;
